(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallController', PhoneCallController);

    /* Added $scope, UIFormAccess, $filter, Principal, PhoneCallCheckTrackerService, Division, $translate
    PhoneCallController.$inject = ['$state', 'PhoneCall', 'PhoneCallSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallController($state, PhoneCall, PhoneCallSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallController.$inject = ['$scope', '$state', 'PhoneCall', 'PhoneCallSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter', 'Principal', 'PhoneCallCheckTrackerService', 'Division', '$translate', '$timeout'];

    function PhoneCallController ($scope, $state, PhoneCall, PhoneCallSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter, Principal, PhoneCallCheckTrackerService, Division, $translate, $timeout) {
        var vm = this;
        vm.timer = null;

        vm.divisionsFilterData = {
                pagingParams: pagingParams,
                division: {id:pagingParams.divisionId},
                divisions: null,
                loadAll: transition
        };

        vm.infoCallBack = infoCallBack;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
            PhoneCallCheckTrackerService.setListener().then(
                null, null,
                function (dto) {
                    infoCallBack(dto);
                }
            );
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        /*
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        */
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.UIFormAccess = UIFormAccess;
        /*
        loadAll();
        */
        // search with time limits
        vm.inCallsHideFilter = pagingParams.inCallsHideFilter == 'true';
        vm.outCallsHideFilter = pagingParams.outCallsHideFilter == 'true';
        vm.missedCallsHideFilter = pagingParams.missedCallsHideFilter == 'true';
        vm.insignificantFilter = pagingParams.insignificantFilter == 'true';
        vm.uncheckedOnlyFilter = pagingParams.uncheckedOnlyFilter == 'true';
        vm.repeatedCallsFilter = pagingParams.repeatedCallsFilter == 'true';
        vm.dateFilterData = {
                allActive: true,
                search: search,
                searchQuery: vm.searchQuery,
                setFilterType: function(){},
                pagingParams: pagingParams,
                initCallBack: loadAll
        };


        vm.PrincipalIsAdmin = false;
        Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
            if (result) {
                vm.PrincipalIsAdmin = true;
            }
        });

        vm.PrincipalIsManager = false;
        Principal.hasAuthority('ROLE_MANAGER').then(function (result) {
            if (result) {
                vm.PrincipalIsManager = true;
            }
        });

        vm.accessToStateEditPhoneCallCheck = UIFormAccess.checkStateAccess('phone-call.editPhoneCallCheck');
        vm.accessToStateNewPhoneCallCheck = UIFormAccess.checkStateAccess('phone-call.newPhoneCallCheck');
        vm.accessToStateEdit = UIFormAccess.checkStateAccess('phone-call.edit');

        $scope.dynamicPopover = {
            //---This is need to load tooltip from template--//
            content: 'player',
            templateUrl: 'popoverTemplateId',
            title: 'Records'
        };

        $scope.openPlayer = function(phoneCall, autoplay) {
            if(autoplay) {
                phoneCall.isPopoverPlaying = false;
            }
            var audio = $('audio#audio-'+phoneCall.id);
            if(audio.length > 0) {
                phoneCall.isPopoverPlaying = !audio[0].paused;
            }
        };

        $scope.playerSetSpeed = function(elID, speed) {
            var audio = document.getElementById('audio-'+elID);
	    audio.playbackRate = speed; 
        };

        function preLoadAll () {
            var t = vm.timer;
            vm.timer = null;
            if (t != null) {
                $timeout.cancel(t);
                loadAll();
            }
        }
        vm.lastLoaded = 0;

        function loadAll () {
            var now = (new Date()).getTime();
            if (vm.lastLoaded + 2000 > now) {
                console.log('Protection from game: lastLoaded=' + vm.lastLoaded + ', now=' + now);
                return;
            }
            vm.lastLoaded = now;
            console.log('LOADING: lastLoaded=' + vm.lastLoaded);
            console.log($scope);
            if (pagingParams.search) {
                PhoneCallSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    /*
                    sort: sort()
                    */
                    sort: sort(),
                    // search with time limits
                    startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                    endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0),
                    statusInHide: vm.inCallsHideFilter,
                    statusOutHide: vm.outCallsHideFilter,
                    statusMissedHide: vm.missedCallsHideFilter,
                    insignificant: vm.insignificantFilter,
                    unchecked: vm.uncheckedOnlyFilter,
                    repeated: vm.repeatedCallsFilter,
                    divisionId: vm.divisionsFilterData.division == null ? null : vm.divisionsFilterData.division.id
                }, onSuccess, onError);
            } else {
                PhoneCall.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    /*
                    sort: sort()
                    */
                    sort: sort(),
                    // search with time limits
                    startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                    endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0),
                    statusInHide: vm.inCallsHideFilter,
                    statusOutHide: vm.outCallsHideFilter,
                    statusMissedHide: vm.missedCallsHideFilter,
                    insignificant: vm.insignificantFilter,
                    unchecked: vm.uncheckedOnlyFilter,
                    repeated: vm.repeatedCallsFilter,
                    divisionId: vm.divisionsFilterData.division == null ? null : vm.divisionsFilterData.division.id
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'callTime') {
                    result.push('callTime,desc');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                // Mark editing
                data.forEach(function(item){
                    if (item.phoneCallCheck == null) {
                        var dto = PhoneCallCheckTrackerService.checkPhoneCallId(item.id)
                        if (dto != null && dto['action'] == 'edit') {
                            item.phoneCallCheck = 'editing';
                        } else if (item.phoneCallCheck == 'editing' && dto == null) { //|| dto['action'] != 'edit'
                            item.phoneCallCheck = null;
                        }
                    }
                });

                vm.phoneCalls = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                /*
                search: vm.currentSearch
                */
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null,
                inCallsHideFilter: vm.inCallsHideFilter,
                outCallsHideFilter: vm.outCallsHideFilter,
                missedCallsHideFilter: vm.missedCallsHideFilter,
                insignificantFilter: vm.insignificantFilter,
                uncheckedOnlyFilter: vm.uncheckedOnlyFilter,
                repeatedCallsFilter: vm.repeatedCallsFilter,
                divisionId: vm.divisionsFilterData.division == null ? null : vm.divisionsFilterData.division.id
            });
        }

        /*
        function search(searchQuery) {
            if (!searchQuery){
        */
        function search() {
            var searchQuery = vm.searchQuery;
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all'){
                return vm.clear(true);
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'callTime';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            */
            vm.transition();
        }

        function clear(fromSearch) {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            vm.reverse = true;
            */
            vm.predicate = 'callTime';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            if (!fromSearch) {
                vm.divisionsFilterData.division = {id:null};
            }
            vm.transition();
        }

        function makeAction(dto, callBack) {
            if (vm.phoneCalls != null) {
                for(var i=0;i<vm.phoneCalls.length;i++) {
                    if(vm.phoneCalls[i]['id'] == dto.phoneCallId) {
                        callBack(vm.phoneCalls[i]);
                        break;
                    }
                }
            }
        }

        function infoCallBack(dto) {
            //console.log("INFO CALL BACK:");
            //console.log(dto);
            if (dto.action == 'edit') {
                makeAction(dto, function(p){
                    if (p['phoneCallCheck'] == null) {
                        p['phoneCallCheck'] = 'editing';
                    }
                });
            } else if (dto.action == 'close') {
                makeAction(dto, function(p){
                    if (p['phoneCallCheck'] == 'editing') {
                        p['phoneCallCheck'] = null;
                    }
                });
            } else if (dto.action == 'save') {
                makeAction(dto, function(p){
                    if (vm.timer == null) {
                        vm.timer = $timeout(preLoadAll, 2000);
                    }
                });
            } else if (dto.action == 'clean') {
                if (vm.timer == null) {
                    vm.timer = $timeout(preLoadAll, 2000);
                }
            }
        }

    }
})();
